import { PropsWithChildren, ReactNode } from 'react';

import classNames from 'classnames';

import useFloatingContainer, { UseFloatingContainerOptions } from '../FloatingContainer/useFloatingContainer';

import styles from './index.module.scss';

export type TooltipProps = PropsWithChildren & {
  className?: string;
  side?: UseFloatingContainerOptions['placement'];
  text?: ReactNode;
};

export default function Tooltip({ children, className, text, side = 'top' }: TooltipProps): ReactNode {
  const { FloatingContainer, getReferenceProps, setOpen } = useFloatingContainer({
    placement: side,
    enableHover: true,
    enableArrow: true,
  });

  if (!text) {
    return children;
  }

  return (
    <>
      <span className={styles.tooltipContainer} {...getReferenceProps()}>
        {children}
      </span>

      <FloatingContainer className={styles.tooltipFloatingContainer}>
        <div className={classNames(styles.tooltip, className)} role="tooltip">
          {text}
        </div>
      </FloatingContainer>
    </>
  );
}
